import { PermissionDto } from "../permissions/permissions.dto";

export interface RoleDto {
  id: string;
  name: string;
  normalizedName: string;
  permissions: PermissionDto[];
}

export interface CreateRoleDto {
  name: string;
  rawPermissions: string[];
}

export interface UpdateRoleDto {
  id: string;
  name: string;
  rawPermissions: string[];
}

export enum ApplicationRoles {
  ApplicationReviewer = "ApplicationReviewer",
  PlanningAdmin = "PlanningAdmin",
  SystemAdmin = "SystemAdmin",
  SuperAdmin = "SuperAdmin",
  Auditor = "Auditor",
  Accountant = "Accountant",
  APRAdmin = "APRAdmin",
  User = "User",
  APROfficer="APROfficer"
}
